<template>
  <modal-vue @close="handleToggleModal" :modalActive="modals[modalName]">
    <template #header>
      <p class="font-bold">Excluir posição</p>
    </template>
    <p class="text-base font-normal">
      Tem certeza que deseja excluir a posição?<br />Essa ação não poderá ser desfeita!
    </p>
    <template #footer>
      <div class="flex justify-center gap-4">
        <filled-button width="119px" @click="handleToggleModal" text="Cancelar" />
        <outline-button
          :disabled="isLoading"
          :loading="isLoading"
          text="Excluir"
          width="119px"
          @click="handleRemove"
        />
      </div>
    </template>
  </modal-vue>
</template>

<script lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import Network from '@/Network'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { useErrorToast } from '@/composables/useErrorToast'

export default {
  components: {
    ModalVue,
    OutlineButton,
    FilledButton
  },
  props: {
    positionId: { required: true, type: Number }
  },
  setup(props) {
    const modalName = EModals.REMOVE_POSITION
    const modalStore = useModalStore()
    const scheduleStore = useScheduleStore()
    const { notifyError } = useErrorToast()
    const { modals } = storeToRefs(useModalStore())

    const successRemove = ref(false)
    const isLoading = ref(false)

    const handleToggleModal = () => {
      modalStore.toggleModal(modalName)
    }

    const handleRemove = async () => {
      if (!props.positionId) return
      try {
        isLoading.value = true
        await Network.position.remove(props.positionId)
        // Refetch isolado: a exclusão já foi persistida — falha do reload não
        // pode interromper o fluxo de sucesso do modal.
        await scheduleStore
          .getSchedulesForPage()
          .catch((error) => notifyError(error, 'Não foi possível recarregar as escalas'))

        modalStore.alertDescription = 'Posição excluida com sucesso!'
        modalStore.toggleModal(modalName)
        modalStore.toggleShowAlert()
      } finally {
        isLoading.value = false
      }
    }

    return { modalName, modals, successRemove, isLoading, handleToggleModal, handleRemove }
  }
}
</script>
